<template>
  <v-row>
    <v-col class="pr-0">
      <div class="card-actions justify-start">
        <div class="card-title-wrapper">
          <h4 class="card-title mr-1">Digital Risk Overview - </h4>
          <p class="card-subtitle">  {{ riskOverviewDate && $moment(riskOverviewDate).format('MMMM YYYY')}}</p>
        </div>
        <v-btn
          text
          class="action-btn csv-icon"
          :disabled="shouldDisable"
        >
          <img @click="downloadCSV" style="position: relative; top: 8px" :src="require('@/assets/icons/download.svg')" :alt="'file'">
        </v-btn>
        <v-btn
          text
          class="action-btn"
          :disabled="shouldDisable"
          @click="handleCapture"
        >
          <img style="position: relative; top: 7px" :src="require('@/assets/icons/camera.svg')" :alt="'file'">
        </v-btn>
        <div class="switch-bool ml-4 pt-1">
         <label for="str">Structured</label>
         <v-switch
            :input-value="unStructured"
            id="str"
            color="#3ACA56"
            dense
            :ripple="false"
            class="ma-0"
            hide-details
            @change="handleDstChange"
         />
        <label for="str">Unstructured</label>
      </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import exportJsonToCSV from '../../mixins/exportJsonToCSV'
import moment from 'moment'

export default {
  name: 'OverviewRiskActions',
  mixins: [exportJsonToCSV],
  computed: {
    ...mapState('dashboardServices', ['riskOverviewLoading', 'unStructured', 'riskOverviewDate', 'zoomTreeMap', 'riskOverviewData']),
    ...mapGetters(['user', 'currentOrganization']),
    shouldDisable () {
      const isDemoMode = process.env.VUE_APP_MODE === 'demo'
      if (this.riskOverviewLoading || !Object.keys(this.riskOverviewData).length || isDemoMode) {
        return true
      }
      return false
    }
  },
  methods: {
    handleDstChange (e) {
      this.$store.commit('dashboardServices/SET_UNSTRUCTURED', Boolean(e))
      this.$store.dispatch('dashboardServices/loadZoomTreeMapData')
    },
    handleCapture () {
      this.$emit('onCapture')
    },

    async downloadCSV () {
      var headers = {
        collection_name: 'Collection'.replace(/,/g, ''), // remove commas to avoid errors
        data_risk_aggregation: 'Digital Risk Aggregation',
        data_structure_type: 'Structure Type',
        elements: 'Elements',
        size: 'Collection Size - in bytes',
        records: 'Records',
        month: 'Month',
        year: 'Year'
      }
      const itemsNotFormatted = this.zoomTreeMap.children
      const itemsFormatted = []
      // format the data
      itemsNotFormatted.forEach((item) => {
        itemsFormatted.push({
          collection_name: item.collection_name.replace(/,/g, ''), // remove commas to avoid errors
          data_risk_aggregation: item.data_risk_aggregation,
          data_structure_type: item.data_structure_type,
          elements: item.elements,
          size: item.size,
          records: item.records,
          month: item.month,
          year: item.year
        })
      })

      var fileTitle = 'Digital Risk Overview' // or 'my-unique-title'
      const payload = {
        organization_id: this.currentOrganization.entity_id,
        user_id: this.user.user_id,
        number_of_records: itemsFormatted.length,
        datetime: moment().unix(),
        source: 'Risk'
      }
      const data = await this.$store.dispatch('addExport', payload)
      data && this.exportCSVFile(headers, itemsFormatted, fileTitle)
    }
  }
}
</script>

<style scoped>

</style>
